<script>
export default {
	name: "BaseTabView",

	render() {
		// prefixes denote slot prop types
		// p for component props
		// m for component methods
		return this.$scopedSlots.default({
			pTabs: this.dTabs,
			mSelect: this.select,
			mFirstTab: this.firstTab,
			mPrevTab: this.prevTab,
			mNextTab: this.nextTab,
			mLastTab: this.lastTab
		});
	},

	data() {
		return {
			dActive: 0,
			dFocused: -1
		};
	},

	props: {
		tabs: {
			type: Array,
			default: () => []
		},

		active: {
			type: Number,
			default: 0
		}
	},

	computed: {
		dTabs() {
			return this.tabs.map((tab, index) => {
				const dTab = {
					disabled: false,
					...tab,
					active: false,
					focused: false
				};

				if (index === this.dActive) {
					dTab.active = true;
				}

				if (index === this.dFocused) {
					dTab.focused = true;
				}

				return dTab;
			});
		}
	},

	methods: {
		select(index) {
			this.dActive = index;
			this.dFocused = index;

			// Emit the clicked tab index
			if (this.tabs[index]) {
				this.$emit("clicked-tab-index", index);
			}
		},

		firstTab() {
			const index = 0;

			if (!this.dTabs[index].disabled) {
				this.dActive = 0;
				this.dFocused = 0;
			}
		},

		prevTab() {
			const index = Math.max(0, this.dActive - 1);

			if (!this.dTabs[index].disabled) {
				this.dActive = index;
				this.dFocused = index;
			}
		},

		nextTab() {
			const index = Math.min(this.dTabs.length - 1, this.dActive + 1);

			if (!this.dTabs[index].disabled) {
				this.dActive = index;
				this.dFocused = index;
			}
		},

		lastTab() {
			const index = this.dTabs.length - 1;

			if (!this.dTabs[index].disabled) {
				this.dActive = index;
				this.dFocused = index;
			}
		},

		updateActive() {
			this.dActive = Math.min(
				Math.max(0, this.active),
				Math.max(0, this.tabs.length - 1)
			);
		},

		updateFocused(index) {
			this.dFocused = Math.min(
				Math.max(-1, index),
				Math.max(-1, this.tabs.length - 1)
			);
		}
	},

	watch: {
		tabs: {
			immediate: true,
			handler: function () {
				// update active state
				this.updateActive();
			}
		},

		active: {
			immediate: true,
			handler: function () {
				// update active state
				this.updateActive();
			}
		},

		dActive: {
			immediate: true,
			handler: function (index) {
				this.$emit("active-changed", index);
			}
		}
	}
};
</script>
